import { createLogic } from 'redux-logic';
import { videoStorage } from 'utils';

// Action Types
const FETCH = '@@app/videoResume/FETCH';
const FETCH_SUCCESS = '@@app/videoResume/FETCH_SUCCESS';
const FETCH_ERROR = '@@app/videoResume/FETCH_ERROR';
const UPDATE = '@@app/videoResume/UPDATE';
const DESTROY = '@@app/videoResume/DESTROY';

// Initial State
export const initialState = {
  loading: false,
  data: {},
};

// Observables
const fetchLogic = createLogic({
  type: FETCH,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR,
  },
  process() {
    return videoStorage.get();
  },
});

const updateLogic = createLogic({
  type: UPDATE,
  process({ action }) {
    const { videoId, currentTime } = action.payload;
    return videoStorage.set(videoId, currentTime);
  },
});

const destroyLogic = createLogic({
  type: DESTROY,
  process({ action }) {
    return videoStorage.remove(action.payload.videoId);
  },
});

export const videoResumeLogic = [fetchLogic, updateLogic, destroyLogic];

// Action Creators
export const destroyVideo = videoId => {
  return { type: DESTROY, payload: { videoId } };
};

export const fetchVideo = () => {
  return { type: FETCH };
};

export const updateVideo = (videoId, currentTime) => {
  return { type: UPDATE, payload: { videoId, currentTime } };
};

// Selectors
export const selectVideos = ({ data }) => {
  return data || {};
};

export const selectVideo = (state, videoId) => {
  return selectVideos(state)[videoId];
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case FETCH: {
      return {
        ...state,
        loading: true,
      };
    }

    case FETCH_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: payload,
      };
    }

    case UPDATE: {
      const { videoId, currentTime } = payload;

      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          [videoId]: currentTime,
        },
      };
    }

    case DESTROY: {
      const { videoId } = payload;
      const data = { ...state.data };

      delete data[videoId];

      return {
        ...state,
        loading: false,
        data,
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/logic/videoResume.js